module.exports = __webpack_public_path__ + "images/2d80b6e797a4ca06c89241dcd5935ef8.svg";